import { render, staticRenderFns } from "./returnVisit.vue?vue&type=template&id=2fbd5533&"
import script from "./returnVisit.vue?vue&type=script&lang=js&"
export * from "./returnVisit.vue?vue&type=script&lang=js&"
import style0 from "./returnVisit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbd5533')) {
      api.createRecord('2fbd5533', component.options)
    } else {
      api.reload('2fbd5533', component.options)
    }
    module.hot.accept("./returnVisit.vue?vue&type=template&id=2fbd5533&", function () {
      api.rerender('2fbd5533', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/complaintQuery/returnVisit.vue"
export default component.exports